import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';
import { NavigationService } from '../services/navigation.service';
import { ChannelService } from 'src/app/home/channel/channel.service';

@Injectable({
  providedIn: 'root'
})
export class OrderDetailGuardGuard implements CanActivate {
  id: number;

  constructor(
    private sessionStorageService: SessionStorageService,
    @Inject(PLATFORM_ID) private platformId: object,
    private navigationService: NavigationService,
    private channelService : ChannelService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if (isPlatformServer(this.platformId)) {
      return false;
    }

    let activityGuid = route.queryParams.activityGUID;
    let orderTranId = route.queryParams.orderTranId;

    let currentRoute = this.channelService.getCurrentRouteName();

    if(this.sessionStorageService.getItem("orderSummary")) {
      this.sessionStorageService.removeItem("orderSummary");
    }

    if(activityGuid || orderTranId){
      return true;
    }
    else if(currentRoute == "order-payment" && this.sessionStorageService.getItem("qrPayment")){
      let activityJson = {activityId: JSON.parse(this.sessionStorageService.getItem("qrPayment")).activityId}
      this.sessionStorageService.setItem("orderDetail", JSON.stringify(activityJson) );
      return true;
    }
    else if (this.sessionStorageService.getItem("orderDetail") && JSON.parse(this.sessionStorageService.getItem("orderDetail")).activityId) {
      return true;
    } else {
      this.navigationService.navigate(['my-order']);
      return false;
    }
  }
}
